import { registerView, View, ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import * as React from "react";
import { Alert, Form } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import MethodOfSignature from "views/notice/components/methodOfSignature";
import Toolbox from "../components/toolbox";
import LoadingModal from "../../common/loadingModal/loadingModal";
import ErrorCard from "../../common/error/errorCard";
import DocumentUploader from "../components/documentUploader";
import RefundRequestViewModel from "../../../viewModels/notice/refundRequest/refundRequestViewModel";
import AlertWithInfoIcon from "../../common/alertWithInfoIcon/alertWithInfoIcon";
import RefundReasonSelect from "./refundReasonView";
import OrderSourceTypeView from "./orderSourceTypeView";

const RefundRequestView: ViewComponent<RefundRequestViewModel> = observer(({ vm }) => {
  const formRef = useCallback((node) => {
    if (node !== null) {
      vm.formElement = node;
    }
  }, []);

  const refundFeeInformation = vm.translateGeneral("refundFeeInformation").replace("%link%", vm.termsAgreementDocumentPath);

  return (
    <>
      <View vm={vm.outagesViewModel} />
      <div className="bg-white p-3 p-lg-4 p-xl-7 rounded">
        <Form className="p-3 p-lg-4 p-xl-7" ref={formRef}>
          <div>
            <h1 className="h3">{vm.translateGeneral("title")}</h1>
          </div>
          <ErrorCard message={vm.errorMessage} sticky={true} />
          <View vm={vm.vehicleInfoViewModel} />

          <RefundReasonSelect vm={vm} />

          <OrderSourceTypeView vm={vm} />
          <View vm={vm.applicantPersonViewModel} />
          <div className="mb-7">
            <AlertWithInfoIcon className="font-weight-bold">
              <ReactMarkdown linkTarget="_blank">{refundFeeInformation}</ReactMarkdown>
            </AlertWithInfoIcon>
          </div>
          <MethodOfSignature vm={vm} />
          <DocumentUploader vm={vm} translateKey={"refundRequest"} />
          {vm.customerRefundApplicationProduction &&
            !vm.customerRefundApplicationProduction?.rejectionReason &&
            vm.customerRefundApplicationProduction.warningReasons?.map((instruction) => (
              <Alert key={instruction} variant="warning">
                <ReactMarkdown linkTarget="_blank">{vm.translateWarningReason(instruction)}</ReactMarkdown>
              </Alert>
            ))}
          {vm.customerRefundApplicationProduction && vm.customerRefundApplicationProduction.rejectionReason && (
            <Alert key={vm.customerRefundApplicationProduction.rejectionReason} variant="danger">
              <strong className="font-size-sm">
                {vm.translateWarningReason(vm.customerRefundApplicationProduction.rejectionReason)}
              </strong>
            </Alert>
          )}
          <Toolbox vm={vm} />
          <LoadingModal translate={vm.translateGeneral} isVisible={vm.showLoadingModal} />
        </Form>
      </div>
    </>
  );
});

registerView(RefundRequestView, RefundRequestViewModel);
